import { Skeleton } from "antd";

export const ChatLeftSkeleton = () => {
  return (
    <div style={{ padding: "16px" }}>
      {[...Array(6)].map((_, index) => (
        <div
          key={index}
          style={{
            marginBottom: "16px",

            gap: "12px",
          }}
          className="flex align-center"
        >
          <Skeleton.Avatar active size={50} />
          <div style={{ flex: 1 }}>
            <Skeleton.Input
              active
              size="small"
              style={{ marginTop: "5px", height: "16px" }}
              block
            />
            <Skeleton.Input
              active
              size="small"
              style={{ marginTop: "5px", height: "16px" }}
              block
            />
            <Skeleton.Input
              active
              size="small"
              style={{ marginTop: "5px", height: "16px" }}
              block
            />
          </div>
        </div>
      ))}
    </div>
  );
};
